<template>
  <div class="pravo-sirsi__welcome__button">
    <router-link to="/join">
      <div class="pravo-sirsi__welcome__button__img">
        <div class="pravo-sirsi__welcome__button__img__img"></div>
      </div>
      <span class="pravo-sirsi__welcome__button__text">Game overview</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "ButtonOverview",
};
</script>